import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VimeoPlayer from '@vimeo/player';

import { getAsset } from '../../../../../../../../util/assets';
import PlayButtonIcon from '../../../../../../../../components/icons/PlayButtonIcon';
import { getSortedVideoThumbnails } from '../../../../../../../../util/video';
import Button from '../../../../../../../../components/global/Button';
import DismissButton from '../../../../../../../../components/global/DismissButton';

const propTypes = {
  greetingVideo: PropTypes.shape({
    id: PropTypes.string,
  }),
  onDismiss: PropTypes.func,
};

const VideoGuestBookContributorVideo = ({
  greetingVideo,
  onDismiss,
  title = 'Gallery Name',
}) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoElementRef = useRef(null);
  const vimeoPlayerRef = useRef(null);

  const classes = classNames({
    'video-guest-book-contributor-video': true,
    'video-guest-book-contributor-video-visible': true,
  });

  const videoClasses = classNames({
    'video-guest-book-contributor-video-iframe': true,
    'video-guest-book-contributor-video-iframe-active': videoPlaying,
  });

  const overlayClasses = classNames({
    'video-guest-book-contributor-video-overlay': true,
    'video-guest-book-contributor-video-overlay-active': !videoPlaying,
  });

  const setupVimeoPlayer = () => {
    vimeoPlayerRef.current = new VimeoPlayer(videoElementRef.current);
    vimeoPlayerRef.current.on('ended', () => {
      setVideoPlaying(false);
      onDismiss();
    });
    vimeoPlayerRef.current.on('play', () => {
      setVideoPlaying(true);
    });
    vimeoPlayerRef.current.on('pause', () => {
      setVideoPlaying(false);
    });
  };

  useEffect(() => {
    if (videoElementRef?.current) {
      // Create a vimeoPlayerRef:
      setupVimeoPlayer();
    }
  }, []);

  const thumbnail = getSortedVideoThumbnails(greetingVideo.thumbnails)[
    Math.floor(greetingVideo.thumbnails.length / 2)
  ]?.url;

  return (
    <div className={classes}>
      <iframe
        className={videoClasses}
        title={greetingVideo.name}
        src={`${greetingVideo.embed_url}`}
        allowFullScreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allow="autoplay; fullscreen"
        ref={videoElementRef}
      />
      <Button
        btnStyle="reset"
        onClick={() => {
          vimeoPlayerRef.current.play();
        }}
        className={overlayClasses}
      >
        <img
          src={thumbnail}
          className="video-guest-book-contributor-video-overlay-background"
          alt="background"
        />
        <img
          src={getAsset('/wedding-bells.svg')}
          width="60"
          alt="Wedding bells"
          className="mb-2"
        />
        <p>Welcome to</p>
        <h2>{title}</h2>
        <hr className="my-1" />
        <p className="mb-5">See what the couple has to say</p>

        <PlayButtonIcon size={120} color="#fff" />
        <p className="text-xs mt-2">PLAY</p>

        <h3 className="mt-2">{greetingVideo.name}</h3>
        <p>{greetingVideo.description}</p>
      </Button>
      <DismissButton
        btnStyle="reset"
        className="video-guest-book-contributor-video-dismiss"
        onClick={onDismiss}
      />
    </div>
  );
};

VideoGuestBookContributorVideo.propTypes = propTypes;

export default VideoGuestBookContributorVideo;
